import React from 'react'

function Button() {
  return (
    <div className='text-center mb-5'>
        <a className="it-btn btn-base mr-space" href="tel:0552092011" rel="noopener noreferrer"> <i className="fas fa-phone pr2" ></i> إتصل الأن </a> 
    </div>
  )
}

export default Button